import axios from 'axios';

// Determine API base URL based on current host
const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  
  // Check if accessing from network (not localhost)
  const currentHost = window.location.hostname;
  if (currentHost !== 'localhost' && currentHost !== '127.0.0.1') {
    return `http://${currentHost}:5000/api`;
  }
  
  return 'http://localhost:5000/api';
};

const api = axios.create({
  baseURL: getApiBaseUrl()
});

// Safe localStorage operations
const safeGetToken = () => {
  try {
    return localStorage.getItem('token');
  } catch (error) {
    console.warn('Failed to get token from localStorage:', error);
    return null;
  }
};

const safeClearSession = () => {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // Clear any session-related keys
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith('auth_') || key.startsWith('session_'))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
  } catch (error) {
    console.warn('Failed to clear session from localStorage:', error);
  }
};

api.interceptors.request.use(
  (config) => {
    const token = safeGetToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      safeClearSession();
      // Dispatch logout action to Redux store if available
      if (window.store) {
        window.store.dispatch({ type: 'auth/clearSession' });
      }
      // Only redirect if not already on login page
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;